/* GROUP */
export const GET_BUSINESS = "GET_BUSINESS"
export const GET_BUSINESS_SUCCESS = "GET_BUSINESS_SUCCESS"
export const GET_BUSINESS_CLEAN = "GET_BUSINESS_CLEAN"
export const API_ERROR = "API_ERROR"
